import type {
  CreateBaselineRequest,
  FdsRecipientState,
  KycApproval,
  KycRevocation,
  PayrollBaseline,
  PayrollBaselineHistory,
  RecordKycRequest,
  RevokeKycRequest,
} from "@kkp/api-client";
import { apiRequest } from "./client";

export function getFdsBaseline(
  companyId: string,
): Promise<PayrollBaselineHistory> {
  return apiRequest<PayrollBaselineHistory>({
    path: `/companies/${companyId}/fds/baseline`,
    method: "GET",
  });
}

export function createFdsBaseline(
  companyId: string,
  body: CreateBaselineRequest,
): Promise<PayrollBaseline> {
  return apiRequest<PayrollBaseline, CreateBaselineRequest>({
    path: `/companies/${companyId}/fds/baseline`,
    method: "POST",
    body,
  });
}

export function getFdsRecipients(
  companyId: string,
): Promise<FdsRecipientState[]> {
  return apiRequest<FdsRecipientState[]>({
    path: `/companies/${companyId}/fds/recipients`,
    method: "GET",
  });
}

export function recordKyc(
  companyId: string,
  seqId: string,
  body: RecordKycRequest,
): Promise<KycApproval> {
  return apiRequest<KycApproval, RecordKycRequest>({
    path: `/companies/${companyId}/recipients/${seqId}/kyc`,
    method: "POST",
    body,
  });
}

export function revokeKyc(
  companyId: string,
  seqId: string,
  body: RevokeKycRequest,
): Promise<KycRevocation> {
  return apiRequest<KycRevocation, RevokeKycRequest>({
    path: `/companies/${companyId}/recipients/${seqId}/kyc/revoke`,
    method: "POST",
    body,
  });
}
